import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "disabled"];
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import _head from 'lodash/head';
import _noop from 'lodash/noop';
import castArrayIfPresent from '@tekion/tekion-base/utils/castArrayIfPresent';
var withSingleSelect = function withSingleSelect(WrappedComponent) {
  var WithSelectValueWrapper = function WithSelectValueWrapper(props) {
    var value = props.value,
      disabled = props.disabled,
      restProps = _objectWithoutProperties(props, _excluded);
    var valueAsArray = useMemo(function () {
      return castArrayIfPresent(value);
    }, [value]);
    var handleChange = useCallback(function (_ref) {
      var valueArray = _ref.value,
        option = _ref.option,
        eventDetails = _ref.eventDetails;
      var onChange = props.onChange;
      onChange({
        value: _head(valueArray),
        option: option,
        eventDetails: eventDetails
      });
    }, [value]);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
      isDisabled: disabled,
      onChange: handleChange,
      value: valueAsArray,
      isMulti: false
    }));
  };
  WithSelectValueWrapper.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    disabled: PropTypes.bool
  };
  WithSelectValueWrapper.defaultProps = {
    onChange: _noop,
    value: '',
    disabled: false
  };
  return WithSelectValueWrapper;
};
export default withSingleSelect;